import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ActionsEnum,
  authorizeAccount,
  deleteXeroAccount,
  exportDocumentToXero,
  fetchXeroAccount,
  resetUpdateXeroError,
  updateXeroAccountNetwork,
} from './xero-data.actions';
import { v4 } from 'uuid';
import { Observable } from 'rxjs';
import { onActions } from '../../utils/helpers/redux.helper';
import { Actions } from '@ngrx/effects';

@Injectable()
export class XeroDataDispatcher {
  constructor(private _store: Store<any>, private _actions: Actions) {}

  updateXeroAccountNetwork(
    autoExport: boolean,
    defaultAccountCode: string,
    country: string,
    i2gCurrency: string
  ): Observable<any> {
    const dispatchId = v4();

    this._store.dispatch(
      updateXeroAccountNetwork(
        autoExport,
        defaultAccountCode,
        country,
        i2gCurrency,
        dispatchId
      )
    );

    return onActions(
      this._actions,
      [
        ActionsEnum.UPDATE_XERO_ACCOUNT_NETWORK_SUCCESS,
        ActionsEnum.UPDATE_XERO_ACCOUNT_NETWORK_ERROR,
      ],
      dispatchId
    );
  }

  deleteXeroAccount(): Observable<any> {
    const dispatchId = v4();

    this._store.dispatch(deleteXeroAccount(dispatchId));

    return onActions(
      this._actions,
      [
        ActionsEnum.DELETE_XERO_ACCOUNT_SUCCESS,
        ActionsEnum.DELETE_XERO_ACCOUNT_ERROR,
      ],
      dispatchId
    );
  }

  authorizeAccount(): Observable<any> {
    const dispatchId = v4();

    this._store.dispatch(authorizeAccount(dispatchId));

    return onActions(
      this._actions,
      [
        ActionsEnum.AUTHORIZE_ACCOUNT_SUCCESS,
        ActionsEnum.AUTHORIZE_ACCOUNT_ERROR,
      ],
      dispatchId
    );
  }

  exportDocumentToXero(
    documentId: string,
    documentNumber: string
  ): Observable<any> {
    const dispatchId = v4();

    this._store.dispatch(
      exportDocumentToXero(dispatchId, documentId, documentNumber)
    );

    return onActions(
      this._actions,
      [
        ActionsEnum.EXPORT_DOCUMENT_TO_XERO_SUCCESS,
        ActionsEnum.EXPORT_DOCUMENT_TO_XERO_ERROR,
      ],
      dispatchId
    );
  }

  resetUpdateXeroError() {
    this._store.dispatch(resetUpdateXeroError());
  }

  fetchXeroAccount(): Observable<any> {
    const dispatchId = v4();

    this._store.dispatch(fetchXeroAccount(dispatchId));

    return onActions(
      this._actions,
      [
        ActionsEnum.FETCH_XERO_ACCOUNT_SUCCESS,
        ActionsEnum.FETCH_XERO_ACCOUNT_ERROR,
      ],
      dispatchId
    );
  }
}
